import Checkout from '@/core/model/checkout';
import {computed, reactive} from 'vue';
import ApplicationCheckout from '@/core/model/application-checkout';

interface CheckoutData {
    checkout: null | Checkout;
}

const state = reactive<CheckoutData>({
    checkout: null,
});

export const useCheckoutData = () => {
    const setCheckout = (checkout: Checkout) => {
        state.checkout = checkout;
    }

    const checkout = computed(() => {
        if (state.checkout === null) {
            const emptyCheckout = new Checkout();

            emptyCheckout.init(new ApplicationCheckout(
                [], 0, 0, '', 0, 0, 0
            ), 0, '', '0');

            return emptyCheckout;
        }

        return state.checkout;
    });

    return {
        checkout,
        setCheckout,
    }
}